// extracted by mini-css-extract-plugin
export var footer = "_rl-0";
export var inherit = "_rl-1";
export var input = "_rl-2";
export var modalContent = "_rl-3";
export var quillEditor = "_rl-4";
export var subtitle = "_rl-5";